import { render } from "./BookingVilla.vue?vue&type=template&id=740055fe&scoped=true"
import script from "./BookingVilla.vue?vue&type=script&lang=js"
export * from "./BookingVilla.vue?vue&type=script&lang=js"

import "./BookingVilla.vue?vue&type=style&index=0&id=740055fe&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740055fe"]])

export default __exports__